import React, { Component } from "react";
import LdsVideoPlayer from "../components/LdsVideoPlayer";
import LdsFigureCaption from '../components/LdsFigureCaption';


class Home extends Component {
  render() {
    return (
      <main>
        <section className="section row">
        <div className="col-sm-12 col-md-8 offset-md-2">
        <LdsFigureCaption
            textContent={<>
                <p>
                Lorem Ipsum
                </p>
                <p>...</p>
            </>}
            >
        <LdsVideoPlayer
            aspectRatio="16/9"
            brandBorder={false}
            heading="The Best Tauvid Sample Video"
            
        >
                <iframe id="kaltura_player_105125823" src="
https://cdnapisec.kaltura.com/p/1759891/sp/175989100/embedIframeJs/uiconf_id/24639831/partner_id/1759891?iframeembed=true&playerId=kaltura_player_105125823&entry_id=1_3m3m3q7j&wid=_1759891&flashvars[sideBarContainer.plugin]=true&flashvars[sideBarContainer.position]=left&flashvars[sideBarContainer.clickToClose]=true&flashvars[chapters.plugin]=true&flashvars[chapters.layout]=vertical&flashvars[chapters.thumbnailRotator]=false&flashvars[streamSelector.plugin]=true&flashvars[EmbedPlayer.SpinnerTarget]=videoHolder&flashvars[dualScreen.plugin]=true"
allowfullscreen webkitallowfullscreen mozAllowFullScreen allow="autoplay *; fullscreen *; encrypted-media *"></iframe>
            </LdsVideoPlayer>
            </LdsFigureCaption>
            </div>
        </section>
        
      </main>
    );
  }
}

export default Home;